var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{staticClass:"controls",style:(`border-bottom: 1px solid ${_vm.btnColor}`),attrs:{"id":"pac-input","type":"text","placeholder":"Buscar"}}),_vm._v(" "),_c('div',{attrs:{"id":"map"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }